import * as ActionTypes from "../action-types";

const employee_defaultState = {
  byID: {},
  byCoid: {},
  allIDs: [],
};
 
export const employee = (state = employee_defaultState, action) => {
  let newState = JSON.parse(JSON.stringify(state));

  if (!action) return newState;

  switch (action.type) {
    case ActionTypes.EMPLOYEE_GET_ALL: {
      const employees = action.employee;
      employees &&
        employees.length &&
        employees.map((employee) => {
          const { memid } = employee;
          newState.byID[memid] = employee;

          if (!newState.allIDs.includes(memid)) newState.allIDs.push(memid);
          return null;
        });
      return newState;
    }
    case ActionTypes.EMPLOYEE_GET_ALL_BY_COID: {
      const employees = action.employee;
      employees &&
        employees.length &&
        employees.map((employee) => {
          const { memid } = employee;
          newState.byCoid[memid] = employee;

          if (!newState.allIDs.includes(memid)) newState.allIDs.push(memid);
          return null;
        });
      return newState;
    }
    case ActionTypes.BULK_UPLOAD_EMPLOYEE: {
      const employees = action.employee;

      employees &&
        employees.length &&
        employees.map((employee) => {
          const { memid } = employee;

          newState.byID[memid] = employee;

          if (!newState.allIDs.includes(memid)) newState.allIDs.push(memid);

          return null;
        });
      return newState;
    }
    case ActionTypes.CREATE_EMPLOYEE:
    case ActionTypes.UPDATE_EMPLOYEE: {
      const employee = action.employee;
      const { memid } = employee;

      if (memid) {
        if(action.role === "EMR") {
          newState.byCoid[memid] = employee;
        } else {
          newState.byID[memid] = employee;
        }
        
        if (!newState.allIDs.includes(memid)) newState.allIDs.push(memid);
      }
      return newState;
    }
    case ActionTypes.UPDATE_REMARKCOUNT_EMPLOYEE: {
      const remark = action.remark;

      const { refid, remarkCount } = remark;

      if (refid) {
        newState.byID[refid] = {...newState.byID[refid], remarkCount: remarkCount};
      }

      return newState;
    }
    default: {
      return state;
    }
  }
};
